import React, { useState, useEffect } from 'react';
import { Spinner, Alert, VoucherService, ConfigService } from '../../services';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-tooltip/dist/react-tooltip.css';
import { getProjectList } from '../../services/dashboard.service';
import ConfirmationPop from '../../components/ConfirmationPop';
import 'react-datepicker/dist/react-datepicker.css';
import { formatValue } from '../../utils/Helper';
import generateVoucherCode from '../../helper/Common';
import FormInput from '../../components/FormInput';

const AddEditVoucher = () => {
  let params = useParams();
  let voucherId = params ? params.id : null;
  const navigate = useNavigate();
  const [projectlist, setprojectlist] = useState([]);
  const [project, setProject] = useState('');
  const [isVoucherExists, setIsVaoucherExists] = useState(false);
  const [projectAvailableQty, setProjectAvailableQty] = useState(0);
  const [projectType, setProjectType] = useState('');
  const [isCommonConfirmationPop, setCommonConfirmationPop] = useState(false);
  const [projectData, setProjectData] = useState({});
  const [setExpiryDate] = useState(null);
  const [isConfirmationPopData, setConfirmationPopData] = useState({
    FirstText: '',
    SecondText: '',
    FirstButton: '',
    secondButton: '',
    slug: '',
  });

  const transformToUpperCase = (value) => (value ? value.toUpperCase() : value);
  let validationShape = {
    project_id: Yup.string().required('Project name is required.').nullable(),
    expiry_date: Yup.string().required('Expiry date is required.'),
    token_alloted: Yup.number()
      .required(
        `Number of ${projectData?.investment_type === 'bond' ? 'bonds' : 'tokens'} is required.`,
      )
      .integer(
        `Please enter a valid number of ${projectData?.investment_type === 'bond' ? 'bonds' : 'tokens'}.`,
      )
      .typeError(
        `Please enter a valid number of ${projectData?.investment_type === 'bond' ? 'bonds' : 'tokens'}.`,
      )
      .positive('Please enter a positive number.')
      .max(
        projectAvailableQty,
        `Should not exceed available quantity ${projectData?.investment_type === 'bond' ? 'bonds' : 'tokens'}.`,
      ),
    voucher_code: Yup.string()
      .required('Voucher code is required.')
      .transform(transformToUpperCase)
      .min(8, 'Voucher code must be at minimum 8 characters long.')
      .matches(/^[A-Z0-9_-]*$/, 'Only A-Z, 0-9, _ and - are allowed.'),
  };

  const validationSchema = Yup.object().shape(validationShape).required();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    control,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handleProjectChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === '') {
      setProjectAvailableQty(0);
      setProjectData({});
      setProjectType('');
      setProject('');
      return false;
    }

    setProject(inputValue);

    projectlist.filter((v) => {
      if (v.id == inputValue) {
        setProjectAvailableQty(v.available_qty);
        setProjectData(v);
        setProjectType(v.investment_type);
      }
    });
  };

  useEffect(() => {
    (async () => {
      if (voucherId) {
        await getVoucherDetails();
      }
    })();
    getlist();
  }, []);

  async function getlist() {
    try {
      const response = await getProjectList();
      if (response) {
        setprojectlist(response.data.records);
      }
    } catch (error) {
      Alert.error(error?.message);
    }
  }

  const getVoucherDetails = async () => {
    Spinner.show();
    try {
      let response = await VoucherService.getVoucherDetails(voucherId);

      if (response.status === 'failure') {
        Spinner.hide();
        Alert.error(response.message);
        return false;
      }
      Spinner.hide();
      let expiryDate = response.data.expiry_date
        ? ConfigService.formatDate(response.data.expiry_date, 'dmy')
        : null;
      if (expiryDate) {
        setExpiryDate({
          startDate: expiryDate,
          endDate: expiryDate,
        });
      }

      setProjectData(response.data.project);
      setProjectAvailableQty(response.data.available_qty);

      const savedValues = {
        project_id: response.data.project.id
          ? parseInt(response.data.project.id)
          : '',
        token_alloted: response.data.token_alloted
          ? response.data.token_alloted
          : 0,
        voucher_code: response.data.voucher_code
          ? response.data.voucher_code
          : '',
        expiry_date: expiryDate ? response.data.expiry_date : '',
      };

      setProject(savedValues.project_id);

      reset(savedValues);
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
      return false;
    }
  };

  const checkVoucher = async (e) => {
    if (e.target.value === '') {
      return false;
    }

    try {
      const formData = {
        voucherCode: e.target.value,
        voucher_id: voucherId,
      };

      let response = await VoucherService.checkVoucher(formData);

      if (response?.data) {
        setIsVaoucherExists(true);
        return true;
      } else {
        setIsVaoucherExists(false);
        return false;
      }
    } catch (error) {
      Spinner.hide();
      setIsVaoucherExists(false);
      Alert.error(error.message);
      return false;
    }
  };

  async function onSubmit(_formInput) {
    try {
      let response;

      if (voucherId) {
        response = await VoucherService.updateVoucher(_formInput, voucherId);
      } else {
        response = await VoucherService.createVoucher(_formInput);
      }

      if (response.status === 'failure') {
        Spinner.hide();
        Alert.error(response.message);
        return false;
      }

      Alert.success(response?.message);
      navigate('/vouchers/list');
    } catch (error) {
      Spinner.hide();
      Alert.error(error?.message);
    }
  }

  const confirmationPopHandel = async (slug) => {
    if (slug === 'redirect') {
      setCommonConfirmationPop(false);
      if (voucherId) {
        navigate(`/vouchers/view/${voucherId}`);
      } else {
        navigate('/vouchers/list');
      }
      return false;
    }
  };

  const cancelUpdate = async () => {
    setConfirmationPopData({
      FirstText: 'Are you sure',
      SecondText: 'Do you want to cancel?',
      FirstButton: 'Continue Editing',
      secondButton: 'Yes, Cancel',
      slug: 'redirect',
    });
    setCommonConfirmationPop(true);
    return false;
  };

  const handleGenerateCode = () => {
    const code = generateVoucherCode(12);
    setIsVaoucherExists(false);
    // Use setValue from react-hook-form to set the value
    setValue('voucher_code', code);
  };

  return (
    <div className="">
      <div className="w-full mb-4">
        {voucherId ? (
          <h4 className="text-center">Edit Voucher</h4>
        ) : (
          <h4 className="text-center">Add New Voucher</h4>
        )}
      </div>
      <div className="md:px-10 md:py-12 p-4 bg-brandGray rounded-xl max-w-xl mx-auto">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Project Name */}
            <div className="">
              <p className="margineb-text-size">
                Project
                <span className="common-error-text">*</span>
              </p>

              {projectlist && (
                <select
                  value={project}
                  onInput={handleProjectChange}
                  {...register('project_id', { required: true })}
                  className="mb-2 p-3 border border-gray-300 rounded-md h-12"
                >
                  <option value="">Select Project</option>
                  {projectlist.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              )}

              <div className="common-error-text">
                {errors.project_id?.message}
              </div>
            </div>

            {/* Voucher Code */}
            <div className="">
              <div className="relative">
                <FormInput
                  label="Voucher Code"
                  name="voucher_code"
                  register={register}
                  required={true}
                  type="text"
                  placeholder="X100EBLX7VWZ"
                  className="h-12"
                  onInput={(e) => {
                    e.target.value = e.target.value.toUpperCase(); // Convert input to uppercase
                    checkVoucher(e);
                  }}
                  append={
                    <button
                      className="absolute right-1 top-1 h-9 px-3 text-[14px] bg-brandBlue border-brandBlue text-white rounded-r-md flex items-center justify-center"
                      type="button"
                      onClick={handleGenerateCode}
                    >
                      Generate
                    </button>
                  }
                />
              </div>

              {isVoucherExists === false && (
                <div className="common-error-text">
                  {errors.voucher_code?.message}
                </div>
              )}
              {isVoucherExists && (
                <span className="common-error-text">
                  Voucher already exists
                </span>
              )}
            </div>

            {/* Tokens Allotted */}
            <div className="">
              <FormInput
                label={projectType === 'bond' ? 'No Of Bonds' : 'No Of Tokens'}
                name="token_alloted"
                register={register}
                errors={errors}
                required={true}
                type="number"
                placeholder={
                  projectType === 'bond' ? 'No Of Bonds' : 'No Of Tokens'
                }
                className="h-12"
              />
            </div>

            {/* Expiry Date */}
            <div className="datePickInput">
              <FormInput
                type="date-picker"
                label="Expiry Date"
                name="expiry_date"
                control={control}
                errors={errors}
                required
                placeholder="Expiry Date"
                minDate={new Date()}
                onChange={(date) => {
                  setValue(
                    'expiry_date',
                    date.startDate ? date.startDate : '',
                    {
                      shouldValidate: true,
                      shouldDirty: true,
                    },
                  );
                }}
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
              />
            </div>
          </div>
          <div className="bg-white p-3 rounded-md my-3">
            {projectData?.total_minted && (
              <>
                <div className="flex justify-between text-sm">
                  <div className="font-medium">Total Minted:</div>{' '}
                  <div>{projectData?.total_minted}</div>
                </div>

                <div className="flex justify-between text-sm">
                  <div className="font-medium">Available Quantity:</div>{' '}
                  {/* <div>{projectData?.available_qty}</div> */}
                  <div>{projectAvailableQty}</div>
                </div>

                <div className="flex justify-between text-sm">
                  <div className="font-medium">Nominal Value: </div>{' '}
                  <div>
                    {projectData?.nominal_value
                      ? formatValue(projectData?.nominal_value, {
                          decimalPlaces: 2,
                        })
                      : '0.00'}
                  </div>
                </div>
                <div className="flex justify-between text-sm">
                  <div className="font-medium">Project Type:</div>{' '}
                  <div>
                    {projectData?.investment_type === 'bond'
                      ? 'Bond'
                      : 'Equity'}
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="flex items-center justify-end mt-12 gap-3">
            <button
              type="button"
              onClick={() => cancelUpdate()}
              className="bg-transparent border border-brandBlue gap-3 text-brandBlue mr-3 w-full"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="border bg-brandBlue border-brandBlue text-white w-full"
            >
              {voucherId ? 'Update' : 'Add'}
            </button>
          </div>
        </form>
      </div>
      <ConfirmationPop
        isPop={isCommonConfirmationPop}
        setPop={setCommonConfirmationPop}
        functionCall={confirmationPopHandel}
        FirstText={isConfirmationPopData.FirstText}
        secondText={isConfirmationPopData.SecondText}
        FirstButton={isConfirmationPopData.FirstButton}
        secondButton={isConfirmationPopData.secondButton}
        slug={isConfirmationPopData.slug}
      />
    </div>
  );
};
export default AddEditVoucher;
